/* eslint-disable no-undef */

class Recaptcha {
  constructor() {
    this.config = {
      recaptchaFormButtons: document.querySelectorAll('[data-module="recaptcha"]'),
      key: '6Ldmy2cbAAAAAHslUJLrsuDtIfKSAnEq4tIKFdmn'
    };
  }

  static findParentByTag(element_, tag) {
    let element = element_;
    while (element.tagName !== tag) {
      element = element.parentNode;
    }
    return element;
  }

  static showLoading(_button) {
    const button = _button;
    const buttonText = button.querySelector('.c-button__text');
    const loadingText = button.querySelector('.c-button__text--loader');

    if (!buttonText || !loadingText) return;
    buttonText.style.display = 'none';
    loadingText.style.display = 'inline-block';
    button.style.opacity = 0.5;
  }

  static resetLoading(_button) {
    const button = _button;
    const buttonText = button.querySelector('.c-button__text');
    const loadingText = button.querySelector('.c-button__text--loader');

    if (!buttonText || !loadingText) return;
    buttonText.style.display = 'inline-block';
    loadingText.style.display = 'none';
    button.style.opacity = 1;
  }

  init() {
    const { recaptchaFormButtons, key } = this.config;
    recaptchaFormButtons.forEach(button_ => {
      const button = button_;
      if (button.dataset.initialized) return;

      button.dataset.initialized = true;

      button.insertAdjacentHTML(
        'beforebegin',
        `<div class="grecaptcha-branding">This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</div>`
      );

      const submitInput = document.createElement('button');
      submitInput.type = 'submit';
      submitInput.style.cssText = 'display: none;';

      button.insertAdjacentElement('afterend', submitInput);

      const tokenInput = document.createElement('input');
      tokenInput.type = 'textarea';
      tokenInput.name = 'g-recaptcha-response';
      tokenInput.id = 'g-recaptcha-response';
      tokenInput.style.display = 'none';

      const parentForm = Recaptcha.findParentByTag(button, 'FORM');
      parentForm.appendChild(tokenInput);

      button.addEventListener('click', async e => {
        e.preventDefault();
        const hasParsley = parentForm.classList.contains('js-parsley-form');
        Recaptcha.showLoading(button);
        if (hasParsley) {
          $(parentForm)
            .parsley()
            .validate();
        }
        if (!parentForm.checkValidity()) {
          submitInput.click();
          Recaptcha.resetLoading(button);
          return;
        }

        if (
          hasParsley &&
          !$(parentForm)
            .parsley()
            .isValid()
        ) {
          Recaptcha.resetLoading(button);
          return;
        }

        grecaptcha.ready(() => {
          grecaptcha.execute(key, { action: 'backendtoken' }).then(token => {
            tokenInput.value = token;
            Recaptcha.showLoading(button);
            submitInput.click();
          });
        });
      });
    });
  }
}

export default Recaptcha;
